import { render, staticRenderFns } from "./StreamSidebar.vue?vue&type=template&id=161fd5f9&scoped=true&"
import script from "./StreamSidebar.vue?vue&type=script&lang=js&"
export * from "./StreamSidebar.vue?vue&type=script&lang=js&"
import style0 from "./StreamSidebar.vue?vue&type=style&index=0&id=161fd5f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161fd5f9",
  null
  
)

export default component.exports